/**
 * Defines common states for form components.
 *
 * INITIAL: The form is in the initial input state.
 * ACTIVE: The form has changes that have been made but have not been submitted.
 * EXPIRED: The form has been submitted for processing.
 */
const SubscriptionStatus = {
  INITIAL: 'initial',
  ACTIVE: 'active',
  PAST_DUE: 'past-due',
  EXPIRED: 'expired'
};

export default SubscriptionStatus;



// WEBPACK FOOTER //
// ./src/constants/SubscriptionStatus.js